import { HTTP } from "@/utils/Http";
import { ActionFlowEntryDataCreate } from "../model/action-flow.interface";
import Log from "@/debug/Log";
import { LinkedAsset } from "@/apps/tatar/cashBudget/model/CashBudgetEntry";
import { AssetTypes } from "@/model/AssetTypes";
import MQ from "@/utils/MatchQueryUtils";

class ActionFlowUtilsClass {
  private ACTION_FLOW_BASE = "/api/actionflow";
  private ENTRY_BASE = "/entry";

  async createNewActionFlowEntry({
    entry,
    successCallback,
    errorCallback,
  }: {
    entry: ActionFlowEntryDataCreate;
    successCallback?: () => void;
    errorCallback?: () => void;
  }): Promise<any> {
    try {
      const response = await HTTP.post({
        url: `${this.ACTION_FLOW_BASE}${this.ENTRY_BASE}`,
        target: "EMPTY",
        bodyParams: { ...entry },
      });
      if (response) {
        if (successCallback) {
          successCallback();
        }
        return response; // resolves the promise with the response
      } else {
        if (errorCallback) {
          errorCallback();
        }
        return Promise.reject(new Error("No response received"));
      }
    } catch (error) {
      Log.error(`Error creating ActionFlowEntry`, entry, error);
      if (errorCallback) {
        errorCallback();
      }
      return Promise.reject(error);
    }
  }

  async archiveActionFlowEntry({
    entryId,
    successCallback,
    errorCallback,
  }: {
    entryId: string;
    successCallback: () => void;
    errorCallback: () => void;
  }) {
    try {
      const response = await HTTP.get({
        url: `${this.ACTION_FLOW_BASE}${this.ENTRY_BASE}/${entryId}/archive`,
        target: "EMPTY",
      });

      if (response) {
        if (successCallback) {
          successCallback();
        }
        return;
      } else {
        if (errorCallback) {
          errorCallback();
        }
      }
    } catch (error) {
      Log.error(`Error archiving ActionFlowEntry with ID ${entryId}`, error);
      if (errorCallback) {
        errorCallback();
      }
    }
  }

  async getActionFlowEntriesByAsset(
    linkedAsset: LinkedAsset,
    status?: string
  ): Promise<any> {
    return HTTP.post({
      url: `/asset/list/${AssetTypes.ActionFlow.ActionFlowEntry}`,
      bodyParams: {
        matchQuery: MQ.and(
          MQ.eq("data.linkedAsset.assetId", linkedAsset.assetId),
          MQ.eq("data.linkedAsset.assetType", linkedAsset.assetType),
          status !== undefined ? MQ.eq("data.status", status) : undefined
        ),
      },
    })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        Log.error(
          `Error fetching actionFlow Entries by Asset: (${linkedAsset.assetId} (${linkedAsset.assetType})`,
          error
        );
        throw error;
      });
  }
}

const ActionFlowUtils = new ActionFlowUtilsClass();
export default ActionFlowUtils;
